import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDealers,
  updateDealerStatus,
  shareDealerCredentials,
} from "../../redux/actions/authActions";
import { getOrderList } from "../../redux/actions/orderActions";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaShare, FaUser, FaArrowLeft } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import SearchBar from "../../Pages/Components/SearchBar";
import SortableTable from "../../Pages/Components/SortableTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import clsx from "clsx";
import dayjs from "dayjs";
import { FiX } from "react-icons/fi";
const DealerList = () => {
  const dispatch = useDispatch();
  const dealerListState = useSelector((state) => state.dealerList);
  const {
    loading: shareLoading,
    success,
    error: shareError,
  } = useSelector((state) => state.dealerShare);

  const { loading, dealers, error } = dealerListState;
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [deactivateCoupons, setDeactivateCoupons] = useState(false);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();
  const [hasActiveCoupons, setHasActiveCoupons] = useState(false);
  const [checkingCoupons, setCheckingCoupons] = useState(false);
  const [activeCouponOrders, setActiveCouponOrders] = useState([]);

  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(fetchDealers(userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token]);

  // if (loading) return <p>Loading dealfsetSelectedDealerers...</p>;
  if (error) return <p>Error: {error}</p>;
  console.log("dealers:", dealers);

  // Convert single dealer object to array if needed
  const dealerArray = Array.isArray(dealers)
    ? dealers
    : dealers
      ? [dealers]
      : [];
  const filteredDealers = dealerArray
    .filter((dealer) => {
      const search = searchValue.toLowerCase();
      const firmName = dealer.firm_name?.toLowerCase() || "";
      const name = dealer.name?.toLowerCase() || "";
      const mobile = dealer.mobile?.toLowerCase() || "";
      const status = dealer.is_active ? "active" : "inactive";
      return (
        firmName.includes(search) ||
        name.includes(search) ||
        mobile.includes(search) ||
        status === search
      ); // ← match either
    })

    .filter((dealer) => {
      if (!startDate && !endDate) return true;

      const rawDate = dealer.created_at?.trim();

      // Parse DD-MM-YYYY manually to ISO (YYYY-MM-DD)
      const [day, month, year] = rawDate.split("-");
      if (!day || !month || !year) {
        console.warn(
          "Malformed date string:",
          rawDate,
          "for dealer ID:",
          dealer.order_id
        );
        return false;
      }

      const formattedDate = `${year}-${month}-${day}`;
      const orderDate = dayjs(formattedDate);

      if (!orderDate.isValid()) {
        console.warn(
          "Parsed invalid date:",
          formattedDate,
          "for order ID:",
          order.order_id
        );
        return false;
      }

      const start = startDate ? dayjs(startDate).startOf("day") : null;
      const end = endDate ? dayjs(endDate).endOf("day") : null;

      if (start && orderDate.isBefore(start)) return false;
      if (end && orderDate.isAfter(end)) return false;

      return true;
    });
  // const CustomCalendarContainer = ({ className, children }) => (
  //   <div
  //     className={`${className} mt-10  p-2 rounded-md shadow-lg border bg-white relative`}
  //   >
  //     <div className="flex justify-between items-center px-2 pt-2 pb-1 border-b">
  //       <span className="text-sm font-semibold text-gray-700">
  //         Order Date Range
  //       </span>
  //       <button
  //         type="button"
  //         onClick={() => setDateRange([null, null])}
  //         className="text-indigo-600 text-sm hover:underline"
  //       >
  //         Clear
  //       </button>
  //     </div>
  //     <div className="pt-1">{children}</div>
  //   </div>
  // );

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // optionally, set a filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async () => {
    try {
      const response = await dispatch(
        fetchDealers(userInfo.access_token, { download: true })
      );
      console.log("API response:", response);
      const fileUrl = response?.download_url;

      if (fileUrl) {
        downloadFile(fileUrl);
      } else {
        console.warn("No download URL in response");
      }
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const columns = [
    { label: "Firm Name", key: "firm_name" },
    { label: "Name", key: "name" },

    { label: "Mobile", key: "mobile" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Created At", key: "created_at" },
    { label: "Actions", key: "actions", sortable: false }, // special handling for actions
  ];

  // const handleStatusToggle = (dealer) => {
  //   const newStatus = !dealer.is_active;

  //   dispatch(
  //     updateDealerStatus(
  //       dealer.user_id,
  //       newStatus,
  //       false,
  //       userInfo?.access_token
  //     )
  //   ).then(() => {
  //     // Update dealer status in local state after successful dispatch
  //     // filteredDealers((prevDealers) =>
  //     //   prevDealers.map((d) =>
  //     //     d.user_id === dealer.user_id ? { ...d, is_active: newStatus } : d
  //     //   )
  //     // );
  //     dispatch(fetchDealers(userInfo?.access_token));
  //   });
  // };

  const handleStatusToggle = (dealer, deactivateCoupons) => {
    const newStatus = !dealer.is_active;

    dispatch(
      updateDealerStatus(
        dealer.user_id,
        newStatus,
        deactivateCoupons,
        userInfo?.access_token
      )
    ).then(() => {
      setShowConfirmModal(false);
      dispatch(fetchDealers(userInfo?.access_token));
    });
  };

  const handleShare = (userId) => {
    dispatch(shareDealerCredentials(userId, userInfo?.access_token));
  };

  const renderRow = (dealer) => (
    <tr
      key={dealer.user_id}
      className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold"
    >
      <td className="px-2 py-4 border-b-gray-400">{dealer.firm_name}</td>
      <td className="px-2 py-4 border-b-gray-400">{dealer.name}</td>

      <td className="px-2 py-4 border-b-gray-400">{dealer.mobile}</td>
      <td className="px-2 py-4 border-b-gray-400">{dealer.city || "-"}</td>
      <td className="px-2 py-4 border-b-gray-400">{dealer.state || "-"}</td>
      <td className="px-2 py-4 border-b-gray-400">{dealer.created_at}</td>
      <td className="px-2 py-4 border-b-gray-400">
        <div className="flex items-center gap-2 flex-wrap">
          {!dealer.is_active && (
            <button
              className="px-3 py-1 rounded text-xs bg-green-600 hover:bg-green-600 text-white"
              onClick={() => handleStatusToggle(dealer)}
              disabled={loading}
            >
              Activate
            </button>
          )}

          {dealer.is_active && (
            <button
              title="Deactivate dealer"
              className="px-3 py-1 rounded text-xs bg-red-500 hover:bg-red-600 text-white"
              onClick={async () => {
                setSelectedDealer(dealer);
                setDeactivateCoupons(false);
                setHasActiveCoupons(false);
                setCheckingCoupons(true);

                try {
                  const response = await dispatch(
                    getOrderList(userInfo?.access_token)
                  );

                  const allOrders = response?.data?.data || [];

                  //  Filter orders for the selected dealer only
                  const dealerOrders = allOrders.filter(
                    (order) => order.client_id === dealer.user_id
                  );

                  console.log("Dealer-specific orders:", dealerOrders);
                  const activeOrders = dealerOrders.filter(
                    (order) => order.is_active === true
                  );

                  const hasActive = dealerOrders.some(
                    (order) => order.is_active === true
                  );
                  console.log("Has active coupons?", hasActive);

                  setHasActiveCoupons(hasActive);
                  setActiveCouponOrders(activeOrders); //  store active coupon orders
                } catch (err) {
                  console.error("Failed to fetch coupons:", err);
                  setHasActiveCoupons(false);
                } finally {
                  setCheckingCoupons(false);
                  setShowConfirmModal(true);
                }
              }}
              disabled={loading}
            >
              <FaTrash />
            </button>
          )}

          <button
            title="Edit"
            className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-xs"
            onClick={() => {
              navigate(`/dashboard/createuser`, {
                state: { userData: dealer },
              });
            }}
          >
            <FaEdit />
          </button>

          {/* <button
            title="share"
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs"
            onClick={() => handleShare(dealer.user_id)}
          >
            <FaShare />
          </button> */}
        </div>
      </td>
    </tr>
  );
  return (
    <DashboardLayout>
      <div className="mt-2 max-w-full mx-auto rounded-lg p-2">
        <div className="flex items-center justify-between ">
          <div className="flex items-center space-x-3">
            <button
              onClick={() => navigate(-1)}
              className="hover:text-gray-800"
            >
              <FaArrowLeft size={20} />
            </button>
            <h2 className="text-2xl font-bold text-amber-600 mb-1">
              Dealers List
            </h2>
          </div>

          <div className="flex space-x-2">
            <button
              className="bg-white  flex items-center px-4 py-2 text-sm font-medium text-black border border-gray-500 rounded-md transition"
              onClick={() => {
                navigate("/dashboard/createuser");
              }}
            >
              <FaUser className="mr-2 text-amber-500" /> Create Dealer
            </button>
            <button
              onClick={handleDownload}
              className="bg-white flex items-center px-4 py-2 text-sm font-medium text-black border border-gray-500 rounded-md transition"
            >
              <FiDownload className="w-4 h-4 mr-2 text-amber-500" />
              Export
            </button>
          </div>
        </div>
        <div className="mt-4 flex flex-wrap items-center mb-4 justify-between gap-4">
          <div className="w-2/3 flex flex-wrap gap-4 items-center">
            <SearchBar
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Search by Name / Firm Name"
            />

            <div className="relative w-1/3">
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                isClearable
                placeholderText="Select date range"
                dateFormat="dd MMM yyyy"
                className="placeholder-gray-500 w-full px-4 py-2 border border-gray-500 rounded-md text-sm "
              />
            </div>
          </div>

          <div></div>
        </div>

        {filteredDealers.length === 0 ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            No dealers found
          </p>
        ) : (
          <SortableTable
            columns={columns}
            data={filteredDealers}
            renderRow={renderRow}
          />
        )}
      </div>
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Confirm Deactivation</h2>
            <p className="mb-4">
              Are you sure you want to deactivate this dealer?
            </p>

            {hasActiveCoupons && !checkingCoupons && (
              <>
                <label className="flex items-center gap-2 mb-4">
                  <input
                    type="checkbox"
                    checked={deactivateCoupons}
                    onChange={(e) => setDeactivateCoupons(e.target.checked)}
                  />
                  <span className="text-red-500">
                    Also deactivate all coupons for this dealer
                  </span>
                </label>

                <div className="mb-4 p-4 bg-amber-50 border border-amber-300 rounded shadow-sm text-sm text-gray-800">
                  <h4 className="font-semibold text-gray-950 mb-3">
                    Activated Coupon Order Summary
                  </h4>

                  <div className="mb-2">
                    <span className="font-medium">
                      Total Active Coupon Orders:
                    </span>{" "}
                    <span className="bg-amber-100 text-amber-800 px-2 py-0.5 rounded text-xs font-semibold">
                      {activeCouponOrders.length}
                    </span>
                  </div>

                  <div className="mb-2">
                    <span className="font-medium">Order Details:</span>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                      {activeCouponOrders.map((order) => (
                        <li
                          key={order.order_id}
                          className="bg-white border border-amber-200 px-3 py-2 rounded text-xs flex justify-between items-center"
                        >
                          <div>
                            <span className="font-semibold">Order ID:</span>{" "}
                            {order.order_id}
                          </div>
                          <div>
                            <span className="font-semibold">
                              Active Qr Quantity :
                            </span>{" "}
                            {order.qr_quantity}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            )}

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowConfirmModal(false);
                  setDeactivateCoupons(false);
                }}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  handleStatusToggle(selectedDealer, deactivateCoupons)
                }
                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded"
              >
                Deactivate
              </button>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default DealerList;
